import React from 'react'
import PageContainer from '../../../components/PageContainer'
import { Box, Button, Chip } from '@mui/material'
import { Add, PermIdentity } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import appRoutes from '../../../routes/routeConfig'
import moment from 'moment'
import Filters from '../../../components/Filters'
import { DataGrid } from '@mui/x-data-grid'
import { getStatusColor } from '../../../util'

const UserPermissions = () => {

    const columns = [
        { 
            field: 'sn', headerName: 'S/N', width: 100, sortable: false,
            renderCell: (params) => {
                return (
                <p
                    style={{ margin: 'auto' }}
                >
                    {(params?.api?.getRowIndex(params?.row?.id) || 0) + 1}
                </p>
            )}
        },
        { field: 'roleId', headerName: 'Permission Id', width: 200 },
        { field: 'roleDesc', headerName: 'Permission Desc', width: 200 },
        { 
            field: 'status', headerName: 'Role Status', width: 150, 
            renderCell: (params) => <Chip size='small' color={getStatusColor((params?.row?.status) ? 'active' : 'inactive')} label={<small>{(params?.row?.status) ? 'Active':'Inactive'}</small>} />
        },
        { field: 'createdBy', headerName: 'Created By', width: 200 },
        { field: 'createdDate', headerName: 'Creation Date', width: 200, valueGetter: (params) => (moment(params?.row?.createdDate).format('DD MMMM, YYYY')) },
        { field: 'createdTime', headerName: 'Creation Time', width: 200, valueGetter: (params) => (moment(params?.row?.createdDate).format('hh:mm:ss A')) }
    ]

    return (
        <PageContainer pageTitle='CBN User Permissions' tagline='Manage all CBN user permissions'
            buttonComponent={<>
                {/* <Link to={appRoutes.internal.users.createRoles}>
                    <Button startIcon={<Add />} variant='contained'>Create Permission</Button>
                </Link> */}
            </>}
        >

            {/* <Filters 
                searchFields={[
                    { id: 'permissionId', label: 'Permission Id' },
                    { id: 'status', label: 'Permission Status', type: 'select' },
                    { id: 'createdBy', label: 'Created By' },
                    { id: 'creationDate', label: 'Creation Date', type: 'date' }
                ]}
            /> */}

            <Box>
                <div className='paper' style={{ height: 650, width: '100%', textAlign: 'center' }}>
                    <DataGrid
                        className={'center-first-column' }
                        rows={[]}
                        getRowId={(row) => row.id}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        checkboxSelection={false}
                        disableSelectionOnClick
                    />
                </div>
            </Box>
        </PageContainer>
    )
}

export default UserPermissions